/* unplugin-vue-components disabled */
import Select from 'primevue/select'
export default {
  components: {
    Select
  },
  mixins: [ModelValue(String)],
  props: {
    items: {
      type: Array, required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    description: {
      type: String,
      default: '',
      required: false
    },
    placeholder: {
      type: String, 
      required: false, 
      default: ''
    },
    footnote: {
      type: Boolean, 
      default: true
    },
    required: {
      type: Boolean, 
      default: false,
      required: false 
    },
    errText: {
      type: String,
      default: '\n'
    },
    optionLabel: {
      type: String, default: 'title'
    },
    optionValue: {
      type: String, default: 'value'
    },
    minWidth: {
      type: String, default: '100%'
    },
    small: {
      type: Boolean, default: false
    }
  },
  emits: ['update:valid'],
  computed: {
    valid() {
      if (this.value === undefined || this.value === null || this.value === '') return !this.required
      return !!this.current
    },
    current() {
      return this.items.find(el => el[this.optionValue] === this.value)
    }
  }
}
